<template>
  <v-col class="osm-attribution py-1 px-3 ma-0">
    Kartendaten ©
    <a
        href="https://www.openstreetmap.org/copyright"
        target="_blank"
        rel="noopener noreferrer"
    >
      OpenStreetMap-Mitwirkende
    </a>
  </v-col>
</template>

<script>
export default {
  name: 'OsmAttribution'
}
</script>
